import * as _cm from "./_cm";
import * as _cmFTH from "./_cmFTH";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as hfXLS from "./_hfXLS";

//import * as icv from './icv';
import * as ihdI11 from './ihdI11';
import * as ihv from './ihv';
//import * as icvI11___Mz from './icvI11___Mz';
import * as icvI15___Mz from './icvI15___Mz';

let $dates = [] as ht.ls;
let $hdys = [] as ht.ls; // holiday

const _grtItlz = () => {
  const _sumz = {
    '全体': 0, 
    '日祝': 0, 
    '土曜': 0, 
    '平日': 0
  } as ht.dz;
  $dates.map((_date: ht.s) => {
    _sumz[_date] = 0;
  });
  return _sumz;
};

const _grtDateType = (
  date: ht.s
) => {
  const _dateType = 
    hf.i(date, $hdys) ? // 祝日
      '日祝'
    : hfDTM.cvtDow(date) == '日' ? // 日
      '日祝'
    : hfDTM.cvtDow(date) == '土' ? // 土
      '土曜'
    : '平日'; // 日付種別
  return _dateType;
};

const _grtSht1 = async (pz: {
  _31r_fst: ht.n,
  yearMth: ht.s,
}) => {

  let _shtName = `部屋(${pz.yearMth})`;

  let _hdrs = [
    { key:  1, header: '時間帯区分', width: 20, style: {} },
    { key:  2, header: '部屋', width: 20, style: {}  },
    { key:  3, header: '集計対象', width: 20, style: {}  },
    { key:  4, header: '時間帯', width: 20, style: {}  },
    { key:  5, header: '全体', width: 10, style: {}  },
    { key:  6, header: '平日', width: 10, style: {}  },
    { key:  7, header: '土曜', width: 10, style: {}  },
    { key:  8, header: '日祝', width: 10, style: {}  },
  ];
  $dates.map( (_date: ht.s, _idx: ht.n) => {
    _hdrs.push({
      key: _idx + 9,
      header: hfDTM.f(_date, '日（曜）'),
      width: 5,
      style: {}
    });
  });

  //hf.l(`icvI1z___EzE3 70: here`);
//  const _i11rs = await icvI11___Mz.loadI11rLsAsync({
//    _31r_fst: pz._31r_fst,
//    yearMth: pz.yearMth,
//    i1zrs1100iMnm: 80,
//    lwrType: 2,
//  })

  const _i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    i1zrs1100iMnm: 80,
    lwrType: 2,
  }));

  //hf.l(`icvI1z___EzE3 76: ${hf.s(_i11rs)}`);

  let _bdys = [];

  // 時間帯区分別・部屋別・時間帯別・コマ数
  // 時間帯区分別・部屋別・申請数
  
  let _bdyz = {
    '時間帯区分合計': {
      '部屋合計': {
        '申請数': _grtItlz(),
      }
    }
  } as ht.dz;

  // 集計処理

  _i11rs.map((_i11rz: ht.dz) => {

    const _i11r_pfx = _i11rz._pfx ?? ''; // 時間帯区分

    if (!_bdyz[_i11r_pfx]) {
      _bdyz[_i11r_pfx] = {
        '部屋合計': {
          'コマ数': {
            '時間帯合計': _grtItlz(),
          },
          '申請数': _grtItlz()
        }
      };
    }; 

    const _i10rs = _i11rz?.cldz?.i10rs;
    _i10rs?.map((_i10rz: ht.dz) => {

      const _i10r_pfx = _i10rz._pfx ?? ''; // 部屋

      if (!_bdyz[_i11r_pfx][_i10r_pfx]) {
        _bdyz[_i11r_pfx][_i10r_pfx] = {
          'コマ数': {
            '時間帯合計': _grtItlz(),
          }, 
          '申請数': _grtItlz()
        };
      };

      const _i1zrs = _i10rz?.cldz?.i1zrs;
      _i1zrs?.map((_i1zrz: ht.dz) => {

        // 利用日
        
        const _date = _i1zrz.i1zrd3100s;
        const _dateType = _grtDateType(_date); 
        //hf.l(`icvI1z___EzE3 132: ${_date}`);

        // 申請数の集計

        _bdyz[_i11r_pfx][_i10r_pfx]['申請数']['全体'] += 1;
        _bdyz[_i11r_pfx][_i10r_pfx]['申請数'][_dateType] += 1;
        _bdyz[_i11r_pfx][_i10r_pfx]['申請数'][_date] += 1;

        _bdyz[_i11r_pfx]['部屋合計']['申請数']['全体'] += 1;
        _bdyz[_i11r_pfx]['部屋合計']['申請数'][_dateType] += 1;
        _bdyz[_i11r_pfx]['部屋合計']['申請数'][_date] += 1;

        _bdyz['時間帯区分合計']['部屋合計']['申請数']['全体'] += 1;
        _bdyz['時間帯区分合計']['部屋合計']['申請数'][_dateType] += 1;
        _bdyz['時間帯区分合計']['部屋合計']['申請数'][_date] += 1;

        const _i1z1s = _i1zrz?.cldz?.i1z1s;
        _i1z1s?.map((_i1z1z: ht.dz) => {

//          const _i111z = _i1z1z?.cldz?.i111[0];
          //hf.l(`icvI1z___EzE3 153: ${hf.s(_i1z1z)}`)
          const _i111z = 
            _i1z1z.i1z1i1111f == ihv.otrz._fst ?
              ihv.otrz
            : _i1z1z?.cldz?.i111s[0];
          //hf.l(`icvI1z___EzE3 158: ${hf.s(_i1z1z)}, ${hf.s(_i111z)}`)
          const _i111_pfx = _i111z._pfx ?? ''; // 時間帯

          // コマ数の集計

          if (!_bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]) {
            _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx] = _grtItlz();
          };

          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]['全体'] += 1;
          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx][_dateType] += 1;
          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx][_date] += 1;

          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計']['全体'] += 1;
          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計'][_dateType] += 1;
          _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計'][_date] += 1;

          if (!_bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]) {
            _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx] = _grtItlz();
          }

          _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]['全体'] += 1;
          _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx][_dateType] += 1;
          _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx][_date] += 1;

          _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計']['全体'] += 1;
          _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計'][_dateType] += 1;
          _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計'][_date] += 1;

        });

      })

    });
  });

  // 出力処理

  _i11rs.map((_i11rz: ht.dz) => {

    const _i11r_pfx = _i11rz._pfx ?? ''; // 時間帯区分

    const _i10rs = _i11rz?.cldz?.i10rs;
    _i10rs?.map((_i10rz: ht.dz) => {

      const _i10r_pfx = _i10rz._pfx ?? ''; // 部屋

      const _i111s = _i11rz?.cldz?.i111s;
      _i111s?.map((_i111z: ht.dz) => {

        const _i111_pfx = _i111z._pfx ?? ''; // 時間帯

        //hf.l(`icvI1z___EzE3 200: ${_i11r_pfx}, ${_i10r_pfx}, ${_i111_pfx}, ${hf.s(_bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx])}`)
        const _dz = { // 時間帯区分・部屋・時間帯別コマ数
          1: _i11r_pfx,
          2: _i10r_pfx,
          3: 'コマ数',
          4: _i111_pfx,
          5: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]?.['全体'] ?? 0,
          6: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]?.['平日'] ?? 0,
          7: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]?.['土曜'] ?? 0,
          8: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]?.['日祝'] ?? 0,
        } as ht.dz;
        $dates.map( (_date, _idx) => _dz[_idx + 9] = _bdyz[_i11r_pfx][_i10r_pfx]['コマ数'][_i111_pfx]?.[_date] ?? 0);
        _bdys.push(_dz);

      });

      const _dz2 = {
        1: _i11r_pfx,
        2: _i10r_pfx,
        3: 'コマ数',
        4: '時間帯合計',
        5: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計']['全体'] ?? 0,
        6: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計']['平日'] ?? 0,
        7: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計']['土曜'] ?? 0,
        8: _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計']['日祝'] ?? 0,
      } as ht.dz;
      $dates.map( (_date, _idx) => _dz2[_idx + 9] = _bdyz[_i11r_pfx][_i10r_pfx]['コマ数']['時間帯合計'][_date]);
      _bdys.push(_dz2);

      const _dz3 = {
        1: _i11r_pfx,
        2: _i10r_pfx,
        3: '申請数',
        4: '',
        5: _bdyz[_i11r_pfx][_i10r_pfx]['申請数']['全体'] ?? 0,
        6: _bdyz[_i11r_pfx][_i10r_pfx]['申請数']['平日'] ?? 0,
        7: _bdyz[_i11r_pfx][_i10r_pfx]['申請数']['土曜'] ?? 0,
        8: _bdyz[_i11r_pfx][_i10r_pfx]['申請数']['日祝'] ?? 0,
      } as ht.dz;
      $dates.map( (_date, _idx) => _dz3[_idx + 9] = _bdyz[_i11r_pfx][_i10r_pfx]['申請数'][_date]);
      _bdys.push(_dz3);

    });

    const _i111s = _i11rz?.cldz?.i111s;
    _i111s?.map((_i111z: ht.dz) => {

      const _i111_pfx = _i111z._pfx ?? ''; // 時間帯

      const _dz = {
        1: _i11r_pfx,
        2: '部屋合計',
        3: 'コマ数',
        4: _i111_pfx,
        5: _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]?.['全体'] ?? 0,
        6: _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]?.['平日'] ?? 0,
        7: _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]?.['土曜'] ?? 0,
        8: _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]?.['日祝'] ?? 0,
      } as ht.dz;
      $dates.map( (_date, _idx) => _dz[_idx + 9] = _bdyz[_i11r_pfx]['部屋合計']['コマ数'][_i111_pfx]?.[_date] ?? 0);
      _bdys.push(_dz);

    });

    const _dz2 = {
      1: _i11r_pfx,
      2: '部屋合計',
      3: 'コマ数',
      4: '時間帯合計',
      5: _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計']['全体'] ?? 0,
      6: _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計']['平日'] ?? 0,
      7: _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計']['土曜'] ?? 0,
      8: _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計']['日祝'] ?? 0,
    } as ht.dz;
    $dates.map( (_date, _idx) => _dz2[_idx + 9] = _bdyz[_i11r_pfx]['部屋合計']['コマ数']['時間帯合計'][_date]);
    _bdys.push(_dz2);

    const _dz3 = {
      1: _i11r_pfx,
      2: '部屋合計',
      3: '申請数',
      4: '',
      5: _bdyz[_i11r_pfx]['部屋合計']['申請数']['全体'] ?? 0,
      6: _bdyz[_i11r_pfx]['部屋合計']['申請数']['平日'] ?? 0,
      7: _bdyz[_i11r_pfx]['部屋合計']['申請数']['土曜'] ?? 0,
      8: _bdyz[_i11r_pfx]['部屋合計']['申請数']['日祝'] ?? 0,
    } as ht.dz;
    $dates.map( (_date, _idx) => _dz3[_idx + 9] = _bdyz[_i11r_pfx]['部屋合計']['申請数'][_date]);
    _bdys.push(_dz3);

  });

  const _dz2 = {
    1: '時間帯区分合計',
    2: '部屋合計',
    3: '申請数',
    4: '',
    5: _bdyz['時間帯区分合計']['部屋合計']['申請数']['全体'] ?? 0,
    6: _bdyz['時間帯区分合計']['部屋合計']['申請数']['平日'] ?? 0,
    7: _bdyz['時間帯区分合計']['部屋合計']['申請数']['土曜'] ?? 0,
    8: _bdyz['時間帯区分合計']['部屋合計']['申請数']['日祝'] ?? 0,
  } as ht.dz;
  $dates.map( (_date, _idx) => _dz2[_idx + 9] = _bdyz['時間帯区分合計']['部屋合計']['申請数'][_date]);
  _bdys.push(_dz2);

  return {
    shtName: _shtName,
    hdrs: _hdrs,
    bdys: _bdys,
  }
};

const _grtSht2 = async (pz: {
  _31r_fst: ht.n,
  yearMth: ht.s,
}) => {

  const _shtName = `団体種別(${pz.yearMth})`;

  const _hdrs = [
    { key:  1, header: '団体種別', width: 20, style: {} },
    { key:  2, header: '集計対象', width: 20, style: {}  },
    { key:  3, header: '全体', width: 10, style: {}  },
    { key:  4, header: '平日', width: 10, style: {}  },
    { key:  5, header: '土曜', width: 10, style: {}  },
    { key:  6, header: '日祝', width: 10, style: {}  },
  ];
  $dates.map( (_date, _idx) => {
    _hdrs.push({
      key:  _idx + 7, 
      header: hfDTM.f(_date, '日（曜）'),
      width: 5, 
      style: {}
    });
  });
//hf.l(`icvI1z___EzE3 337: ${hf.s(_hdrs)}`);
//hf.l(`icvI1z___EzE3 338: ${hf.s($dates)}`);

  const _bdys = [] as ht.ls;

  let _bdyAllz = {
    '申請数': _grtItlz(), 
    'コマ数': _grtItlz(), 
    '人数': _grtItlz()
  };

  const _i15rs = await icvI15___Mz.loadI15rLsAsync({
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    i1zrs1100iMnm: 80,
    lwrType: 1,
  });
//hf.l(`icvI1z___EzE3 350: ${hf.s(_i15rs)}`);

  _i15rs.map((_i15rz: ht.dz) => {
    let _i15r_pfx = _i15rz._pfx;
    let _bdySubz = {
      '申請数': _grtItlz(), 
      'コマ数': _grtItlz(), 
      '人数': _grtItlz() 
    };
    const _i18rs = _i15rz?.cldz?.i18rs;
    _i18rs?.map((_i18rz: ht.dz) => {
//hf.l(`icvI1z___EzE3 361: ${hf.s(_i18rz)}`);
      const _i1zrs = _i18rz?.cldz?.i1zrs;
      _i1zrs?.map((_i1zrz: ht.dz) => {
//hf.l(`icvI1z___EzE3 364: ${hf.s(_i1zrz)}`);
        const _date = _i1zrz.i1zrd3100s; // 利用日
        hf.l(`icvI1z___EzE3 372: ${_date}`);
        const _dateType = _grtDateType(_date);
        const _i1z1s = _i1zrz?.cldz?.i1z1s;
        const _cntFrm = _i1z1s?.length ?? 0;
        const _i1z4z = hf.get1(_i1zrz?.cldz?.i1z4s, {});
        const _cntPsn = (_i1z4z.i1z4a1100i ?? 0) + (_i1z4z.i1z4a1200i ?? 0);
        _bdySubz['申請数']['全体'] += 1;
        _bdySubz['申請数'][_dateType] += 1;
        _bdySubz['申請数'][_date] += 1;
        _bdySubz['人数']['全体'] += _cntPsn;
        _bdySubz['人数'][_dateType] += _cntPsn;
        _bdySubz['人数'][_date] += _cntPsn;
        _bdyAllz['申請数']['全体'] += 1;
        _bdyAllz['申請数'][_dateType] += 1;
        _bdyAllz['申請数'][_date] += 1;
        _bdyAllz['人数']['全体'] += _cntPsn;
        _bdyAllz['人数'][_dateType] += _cntPsn;
        _bdyAllz['人数'][_date] += _cntPsn;
        _bdySubz['コマ数']['全体'] += _cntFrm;
        _bdySubz['コマ数'][_dateType] += _cntFrm;
        _bdySubz['コマ数'][_date] += _cntFrm;
        _bdyAllz['コマ数']['全体'] += _cntFrm;
        _bdyAllz['コマ数'][_dateType] += _cntFrm;
        _bdyAllz['コマ数'][_date] += _cntFrm;
      });
    });

//hf.l(`icvI1z___EzE3 395: ${hf.s(_bdySubz['申請数'])}`);
    const _dzB3a = {
      1: _i15r_pfx,
      2: '申請数',
      3: _bdySubz['申請数']['全体'],
      4: _bdySubz['申請数']['平日'],
      5: _bdySubz['申請数']['土曜'],
      6: _bdySubz['申請数']['日祝'],
    } as ht.dz;
    $dates.map( (_date: ht.s, _idx: ht.n) => _dzB3a[_idx + 7] = _bdySubz['申請数'][_date]);
    _bdys.push(_dzB3a);

    const _dzB3b = {
      1: _i15r_pfx,
      2: 'コマ数',
      3: _bdySubz['コマ数']['全体'],
      4: _bdySubz['コマ数']['平日'],
      5: _bdySubz['コマ数']['土曜'],
      6: _bdySubz['コマ数']['日祝'],
    } as ht.dz;
    $dates.map( (_date: ht.s, _idx: ht.n) => _dzB3b[_idx + 7] = _bdySubz['コマ数'][_date]);
    _bdys.push(_dzB3b);

    const _dzB3c = {
      1: _i15r_pfx,
      2: '人数',
      3: _bdySubz['人数']['全体'],
      4: _bdySubz['人数']['平日'],
      5: _bdySubz['人数']['土曜'],
      6: _bdySubz['人数']['日祝'],
    } as ht.dz;
    $dates.map( (_date: ht.s, _idx: ht.n) => _dzB3c[_idx + 7] = _bdySubz['人数'][_date]);
    _bdys.push(_dzB3c);

  });

  const _dzB4a = {
    1: '団体種別合計',
    2: '申請数',
    3: _bdyAllz['申請数']['全体'],
    4: _bdyAllz['申請数']['平日'],
    5: _bdyAllz['申請数']['土曜'],
    6: _bdyAllz['申請数']['日祝'],
  } as ht.dz;
  $dates.map( (_date: ht.s, _idx: ht.n) => _dzB4a[_idx + 7] = _bdyAllz['申請数'][_date]);
  _bdys.push(_dzB4a);

  const _dzB4b = {
    1: '団体種別合計',
    2: 'コマ数',
    3: _bdyAllz['コマ数']['全体'],
    4: _bdyAllz['コマ数']['平日'],
    5: _bdyAllz['コマ数']['土曜'],
    6: _bdyAllz['コマ数']['日祝'],
  } as ht.dz;
  $dates.map( (_date: ht.s, _idx: ht.n) => _dzB4b[_idx + 7] = _bdyAllz['コマ数'][_date]);
  _bdys.push(_dzB4b);

  const _dzB4c = {
    1: '団体種別合計',
    2: '人数',
    3: _bdyAllz['人数']['全体'],
    4: _bdyAllz['人数']['平日'],
    5: _bdyAllz['人数']['土曜'],
    6: _bdyAllz['人数']['日祝'],
  } as ht.dz;
  $dates.map( (_date: ht.s, _idx: ht.n) => _dzB4c[_idx + 7] = _bdyAllz['人数'][_date]);
  _bdys.push(_dzB4c);

  return {
    shtName: _shtName,
    hdrs: _hdrs,
    bdys: _bdys,
  };

};

export const eptExlAsync = async (pz: { // 実績集計表
  _31r_fst: ht.n,
  yearMth: ht.s,
}) => {

  //hf.l(`icvI1z___EzE3 485: ${hfDTM.getNow()}`);

  const _fileName = `実績集計表_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;

  //hf.l(`icvI1z___EzE3 490: ${hfDTM.getNow()}`);

  $dates = hfDTM.cvtDates(
    hfDTM.cvtFdm(`${pz.yearMth}-01`),
    hfDTM.cvtLdm(`${pz.yearMth}-01`)
  );

  //hf.l(`icvI1z___EzE3 497: ${hfDTM.getNow()}`);

  $hdys = await _cv_60___Mz.load_601AsAsync({ // holid days
    yearMth: pz.yearMth,
  })

  //hf.l(`icvI1z___EzE3 503: ${hfDTM.getNow()}`);

  const _shts = [] as ht.ls;

  //hf.l(`icvI1z___EzE3 507: ${hfDTM.getNow()}`);

  _shts.push(await _grtSht1(pz));

  //hf.l(`icvI1z___EzE3 511: ${hfDTM.getNow()}`);

  _shts.push(await _grtSht2(pz));

  //hf.l(`icvI1z___EzE3 515: ${hfDTM.getNow()}`);

  await hfXLS.saveAsync({
    fileName: _fileName,
    shts: _shts,
  })

  //hf.l(`icvI1z___EzE3 522: ${hfDTM.getNow()}`);

};
